export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'category',
    actions: {
      read: true,
    },
  },
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'content-item',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'contest',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'calendar-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'media-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'link-pattern',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'media-embed',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'mlp',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: [
      'cmsState',
      'isMultiArtistPage',
      'options.customCSS',
      'options.customHeader',
      'options.customJs',
      'options.customContainerClass',
      'options.customContainerId',
      'options.customOptions',
      'options.template',
      'sso',
      'shopifyStore',
      'shopifyHasCartPage',
      'template',
      'theme',
      'thumbnail',
      'vhost',
      'version',
    ],
  },
  {
    for: 'mlp-page',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'newsletter',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'live-partner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'media-partner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'person',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'product-element',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'product-family',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'short-url',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'teaser',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: ['youniverseStageAssets', 'youniverseScreenAssets'],
  },
  {
    for: 'story',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'product-track',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'url-alias',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'taxon',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'taxonomy',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-itunes-import',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-mmc-importer',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-itunes-ids-uploader',
    actions: {
      update: true,
      read: true,
    },
  },
];
